import { render, staticRenderFns } from "./SmokingSidebar.vue?vue&type=template&id=509f0d94&scoped=true&"
import script from "./SmokingSidebar.vue?vue&type=script&lang=js&"
export * from "./SmokingSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SmokingSidebar.vue?vue&type=style&index=0&id=509f0d94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509f0d94",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('509f0d94')) {
      api.createRecord('509f0d94', component.options)
    } else {
      api.reload('509f0d94', component.options)
    }
    module.hot.accept("./SmokingSidebar.vue?vue&type=template&id=509f0d94&scoped=true&", function () {
      api.rerender('509f0d94', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/smoking/SmokingSidebar.vue"
export default component.exports